import React from "react"

export const ShapeA = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="260"
    height="320"
    viewBox="0 0 260 320"
    className="nav-tile__background-shape"
  >
    <path
      data-name="shape container"
      d="M143.31,34.148c29.308,5.13,130.864-.8,101.557,60.758s45.631,113.809,0,181.432-96.38,37.2-99.956,34.62-18.242-15.727-39-15.093C4.025,304.118,4.914,256.87.289,227.788-4.4,198.294,49.526,153.409,43.665,122.633s-57.442-94.9-15.239-116.7S114,29.018,143.31,34.148"
      transform="translate(0 0)"
      fill="#111c4e"
      opacity="0.15"
    />
  </svg>
)

export const ShapeB = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="264"
    height="319.736"
    viewBox="0 0 264 319.736"
    className="nav-tile__background-shape"
  >
    <path
      d="M209.12,20.2s-139.812-56-170.6,11.594,19.675,98.919-18.3,126.414-34.359,131.439,48.78,145.186,130.842,32.386,166.765-20.314S274.649,55.32,209.12,20.2"
      transform="translate(2.99 1.578)"
      fill="#111c4e"
      opacity="0.15"
    />
  </svg>
)

export const ShapeC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="260"
    height="321.885"
    viewBox="0 0 260 321.885"
    className="nav-tile__background-shape"
  >
    <path
      d="M50.454,45.77c-23.639,41.947,3.224,64.719-10.744,94.681s-69.843,93.484-18.267,155.806,79.512-10.785,133.236,5.992,104.226-14.381,105.3-50.336-39.5-36.056-24.712-91.187S268.012-14.4,210.553,1.425C123.518,25.4,74.092,3.823,50.454,45.77"
      transform="translate(0 0.001)"
      fill="#111c4e"
      opacity="0.15"
    />
  </svg>
)

export const ShapeD = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="260"
    height="320"
    viewBox="0 0 260 320"
    className="nav-tile__background-shape"
  >
    <path
      data-name="shape container"
      d="M26.016,25.488C-2.936,56.61-43.637,176.772,11.541,261.126S49.4,313,95.055,317.444s135.848,10.373,118.032-81.51,60.131-118.56,18.93-182.287-169.444-67.456-206-28.158"
      transform="translate(15.795 0)"
      fill="#111c4e"
      opacity="0.15"
    />
  </svg>
)
